import { render, staticRenderFns } from "./course_card.vue?vue&type=template&id=359cbcdf&scoped=true"
import script from "./course_card.vue?vue&type=script&lang=ts"
export * from "./course_card.vue?vue&type=script&lang=ts"
import style0 from "./course_card.vue?vue&type=style&index=0&id=359cbcdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359cbcdf",
  null
  
)

export default component.exports